import { configureStore } from '@reduxjs/toolkit'
import {
  testSlice,
  sessionSlice,
  formsSlice,
  analyzersSlice,
  scriptsSlice,
  configsSlice,
  resultsSlice,
  datasetsSlice,
  loadState,
  strategySlice,
  serverSlice,
  accountsSlice,
  notificationsSlice,
  manualUploadsSlice,
  dataSlice,
  UserpreferenceSlice,
  jobQueueSlice,
  initialAnalyzersState,
  initialScriptsState,
  initialConfigsState,
  initialResultsState,
  initialDatasetsState,
  initialServerState,
  initialAccountsState,
  initialNotificationsState,
  initialSessionState,
  initialManualUploadsState,
  initialDataState,
  initialUserPreferenceState,
  initialJobQueueState,
  SessionState,
  FormState,
  AnalyzerState,
  ScriptState,
  ConfigState,
  ResultState,
  DataSetState,
  StrategyState,
  AccountsState,
  NotificationsState,
  ManualUploadState,
  DataState,
  TestState,
  ServerState,
  UserPreferenceState,
  JobQueueState
} from './slices'

export interface DefaultState {
  test: TestState
  session: SessionState
  forms: FormState
  analyzers: AnalyzerState
  scripts: ScriptState
  configs: ConfigState
  results: ResultState
  datasets: DataSetState
  strategies: StrategyState
  server: ServerState
  accounts: AccountsState
  notifications: NotificationsState
  manualUploads: ManualUploadState
  data: DataState
  userPreference: UserPreferenceState
  jobQueue: JobQueueState
}


const store = configureStore<DefaultState>({
  reducer: {
    test: testSlice.reducer,
    session: sessionSlice.reducer,
    forms: formsSlice.reducer,
    analyzers: analyzersSlice.reducer,
    scripts: scriptsSlice.reducer,
    configs: configsSlice.reducer,
    results: resultsSlice.reducer,
    datasets: datasetsSlice.reducer,
    strategies: strategySlice.reducer,
    server: serverSlice.reducer,
    accounts: accountsSlice.reducer,
    notifications: notificationsSlice.reducer,
    manualUploads: manualUploadsSlice.reducer,
    data: dataSlice.reducer,
    userPreference: UserpreferenceSlice.reducer,
    jobQueue: jobQueueSlice.reducer
  },
  preloadedState: {
    test: {},
    session: initialSessionState,
    forms: loadState(),
    analyzers: initialAnalyzersState,
    scripts: initialScriptsState,
    configs: initialConfigsState,
    results: initialResultsState,
    datasets: initialDatasetsState,
    server: initialServerState,
    accounts: initialAccountsState,
    notifications: initialNotificationsState,
    manualUploads: initialManualUploadsState,
    data: initialDataState,
    userPreference: initialUserPreferenceState,
    jobQueue: initialJobQueueState
  },
})

  //middleware: (getDefaultMiddleware) =>
  //  getDefaultMiddleware().concat(dataApi.middleware)

export default store
